import React from 'react';

const THead = () => {
    return (
        <>
            <thead>
                <tr>
                    <th className="th-black text-center col">Data do relatório</th>
                    <th className="th-black text-center col">Solicitante</th>
                    <th className="th-black text-center col">Data inicial</th>
                    <th className="th-black text-center col">Data final</th>
                    <th className="th-black text-center col">Colaborador</th>
                    <th className="th-black text-center col">Centro de custo</th>
                    <th className="th-black text-center col">Empresa</th>
                    <th className="th-black text-center col">Relatórios</th>
                </tr>
            </thead>
        </>
    )
}

export default THead;